import request from '@/utils/request'

// 最新版本数据
export function getNewVersion() {
  return request({
    url: '/operate/version/versionlatest',
    method: 'get',
  })
}

// 系统版本更新列表
export function getVersionList() {
  return request({
    url: '/operate/version/versionList',
    method: 'get'
  })
}

// 手机号（脱敏）
export function getPhone(data) {
  return request({
    url: '/agent/getPhone',
    method: 'get',
    params: data
  })
}